import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Tab1({ tabCount }) {
    const { t } = useTranslation();
    return (
        <div className="font-semibold text-xs">
            {' '}
            {t('TotalItems', { length: tabCount })}
        </div>
    );
}
